import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { IdName } from './../../models/id-name.model';
import { FtReportSubject } from './../../enums/ft-report-subject.enum';

@Pipe({
  name: 'ftReportSubject',
  standalone: false
})
export class FtReportSubjectPipe implements PipeTransform {
  public transform(value: FtReportSubject): string {
    return getFtReportSubject(value);
  }
}

export function getFtReportSubject(value: FtReportSubject): string {
  switch (value) {
    case FtReportSubject.Trainee:
      return 'Trainee';
    case FtReportSubject.Trainer:
      return 'Trainer';
    case FtReportSubject.Program:
      return 'Program';
    default:
      throw new Error(`Unsupported value for FtReportSubject: ${value}.`);
  }
}

export function getFtReportSubjectList(): IdName[] {
  return enumToList(FtReportSubject, getFtReportSubject);
}
